import React from "react";
import flag_2 from "./../assets/img/tarh-parcham-iran-psdtarh2.png";
import { ApiEndpoints, useApiCall } from "../api";
import { useTableDataGenerator } from "../helper/common";
import Loading from "../component/loading";
import Pagination from "../component/pagination";
import MainLayout from "../layout/main";
import { toDateString } from "../helper/dateHelper";
import { MdOutlineFileDownload } from "react-icons/md";
import { Table } from "../component/table";

const ContactUsPage = () => {
  const [[contactUs], { loading }] = useApiCall({
    endpoints: ApiEndpoints.contactUs.list,
  });

  const { data, totalCount, setPage, currentPage, totalPageCount } =
    useTableDataGenerator(contactUs?.data ?? []);

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        <div className="sec1 w-full bg-greenblue-light rounded-3xl relative p-8 md:min-h-[180px] h-[100px]">
          <img src={flag_2} className=" absolute left-0 top-0 md:h-42 h-24" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] h-full mx-auto">
            <div className="md:text-3xl text-xl text-center font-bold">
              <span> ارتباط </span>
              <span className=" text-greenblue">باما</span>
            </div>
          </div>
        </div>

        <Table
          loading={loading}
          data={data}
          hasPagination
          totalPageCount={totalPageCount}
          setPage={setPage}
          currentPage={currentPage}
          header={[
            {
              name: "ردیف",
              width: 1,
              render: (i) => i.rowIndex,
            },
            {
              name: "نام و نام خانوادگی",
              width: 3,
              render: (i) => i.full_name,
            },
            {
              name: "نقش",
              width: 2,
              render: (i) => i.user_type_name,
            },
            {
              name: "استان",
              width: 2,
              render: (i) => i.state_name,
            },
            {
              name: "شماره ثابت",
              width: 2,
              render: (i) => i.phone_number,
            },
            {
              name: "شماره همراه",
              width: 2,
              render: (i) => i.mobile_number,
            },
          ]}
        />
      </div>
    </MainLayout>
  );
};

export default ContactUsPage;
